import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { IBrandOrgItem } from '../interfaces/brand-org-item';
import { IBrandOrgsResponse } from '../interfaces/brand-orgs-response';
import { BRAND_ORGS_API_TOKEN } from '../tokens';

@Injectable()
export class BrandOrganisationsService {
  constructor(
    private http: HttpClient,
    @Inject(BRAND_ORGS_API_TOKEN) private apiUrl: string,
  ) {}

  public fetchMarketOrgs(account: string, search: string) {
    return this.http.get<IBrandOrgItem[]>(`${this.apiUrl}/market`, {
      params: {
        account,
        search,
      },
    });
  }

  public getOrg(id: string, currentUser: boolean = true) {
    return this.http.get<IBrandOrgsResponse>(`${this.apiUrl}`, {
      params: {
        filterByCurrentUser: currentUser.toString(),
        filter: `[['BrandOrganisationId','=','${id}']]`,
      },
    });
  }
}
